import type { AgentTaskModel } from "@fencyai/js";
import { loadFency } from "@fencyai/js";
import { requireStringEnvVar } from "../../config";

export const FENCY_DEFAULT_MODEL: AgentTaskModel = "anthropic/claude-sonnet-4.6";

export const fencyPromise = loadFency({
  publishableKey: requireStringEnvVar("VITE_FENCY_PUBLISHABLE_KEY"),
});
